import React, { useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// Context
import GlobalContext from 'contexts/Global.context';

// SCSS
import styles from './Support.module.scss';

const Support = () => {
  const { variantDetails } = useContext(GlobalContext);
  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      variantDetails?.support_script_url ||
      '//musiciansdeskreference.activehosted.com/f/embed.php?id=130';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className={styles.supportPage}>
      <Container className="p-0">
        <Row>
          <Col md={12}>
            <div className={styles.heading}>Support</div>
            <div className="_form_130"></div>
            <div className="_form_7"></div>
            <div className="_form_11"></div>
            <div
              className={`_form_${variantDetails?.support_script_url?.split('id=')?.[1]}`}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Support;
